import React from 'react';

import { Button } from 'antd';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';

import Loading from '../components/loading';

export const PermissionGuard = ({ requiredPermission = null, children, fallback = null }) => {
    const { user, permissions } = useSelector((state) => state.session);
    const { isLoading } = useSelector((state) => state.session);

    // Skip auth guard if not configurd
    const authGuardEnabled = window._env_?.REACT_APP_ROUTE_AUTH_GUARD === 'true' || process.env.REACT_APP_ROUTE_AUTH_GUARD === 'true';
    if (!authGuardEnabled) return children;

    console.log('Required permission:', requiredPermission);

    // If auth is still loading, show loading state
    if (isLoading) {
        return <Loading />;
    }

    // If user is not logged in, redirect to login
    if (!user) {
        console.warn('User is not logged in, redirecting to login page.');
        return <Navigate to="/login" replace />;
    }

    // If no requiredPermission is provided, allow access (for routes without permission requirements)
    if (!requiredPermission) {
        return children;
    }

    // If no permissions found or required permission not granted
    if (!permissions.includes(requiredPermission)) {
        return fallback;
    }
    // User has the required permission, render children
    return children;
};

// Unauthorized component
export const Unauthorized = () => {
    return (
        <div className="flex flex-col items-center justify-center min-h-screen">
            <h1 className="text-2xl font-bold mb-4">Access Denied</h1>
            <p className="mb-4">You don't have permission to access this page.</p>
            <Button onClick={() => window.history.back()}>Go Back</Button>
        </div>
    );
};
